export default __webpack_public_path__ + "static/media/splash2.a8626b26.jpg";